module.exports = __webpack_public_path__ + "img/melting_nose_lancelot.af9520d3.jpg";